"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavButton = void 0;
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
const pixi_js_1 = require("pixi.js");
const Block_1 = require("./Block");
const WigglyText_1 = require("../objects/WigglyText");
const i18next_1 = __importDefault(require("i18next"));
const Global_1 = require("../Global");
const gsap_1 = require("gsap");
const settings_1 = require("../config/settings");
class NavButton extends Block_1.Block {
    constructor(app, gameManager, source, spritescale, txt, textStyle = Block_1.Block.textStyle(22)) {
        super(app);
        this.spritescale = spritescale;
        this.textpad = 18;
        this.bottompad = 5;
        this.activeoffset = { scale: 1.3, y: -(0, Global_1.px)(8) };
        this.w = 0;
        this.h = 0;
        this.background = new pixi_js_1.Graphics();
        this.background.alpha = 0;
        this.sprite = pixi_js_1.Sprite.from(source);
        this.sprite.anchor.set(0.5);
        this.sprite.scale.set((0, Global_1.px)(this.spritescale));
        this.text = new WigglyText_1.WigglyText(this.app, i18next_1.default.t(txt), textStyle);
        this.text.position.set(0, (0, Global_1.px)(this.textpad));
        this.centerblock = new pixi_js_1.Container();
        this.centerblock.addChild(this.sprite, this.text);
        this.addChild(this.background, this.centerblock);
        this.subs.add(gameManager.langChange$.subscribe(() => {
            this.text.text = i18next_1.default.t(txt);
        }));
        this.timeline = gsap_1.gsap.timeline({ paused: true });
        this.timeline.to(this.sprite, {
            pixi: {
                positionY: 0,
                scale: (0, Global_1.px)(this.spritescale * this.activeoffset.scale),
            },
            duration: 0.15,
            id: 'up'
        });
        this.tms.add(this.timeline);
    }
    setSize(w, h) {
        this.w = w;
        this.h = h;
        this.timeline.getById('up').vars.pixi.positionY = this.activeoffset.y;
        this.layout();
    }
    layout() {
        super.layout();
        this.makeBox({
            backgroundColor: settings_1.Settings.whiteColor,
            width: this.w,
            height: this.h,
            border: 0,
            radius: 0,
        }, this.background);
        this.centerblock.position.set(0, (this.background.height - (0, Global_1.px)(this.textpad + this.bottompad)) / 2);
        this.sprite.position.x = (0, Global_1.px)(this.w / 2);
        this.text.position.set(this.sprite.position.x, (0, Global_1.px)(this.textpad));
        if (this.isLandscapeBox) {
            this.text.anchor.set(0);
            this.text.rotation = Math.PI / 3;
        }
        else {
            this.text.anchor.set(0.5, 0);
            this.text.rotation = 0;
        }
    }
}
exports.NavButton = NavButton;
